// Utilitários de Autenticação JWT
import { desinscreverPush } from '../services/push';

// Obter token do localStorage
export const getToken = () => {
  return localStorage.getItem("token");
};

// Verificar se o usuário está autenticado
export const isAuthenticated = () => {
  const token = getToken();
  return token !== null && token !== undefined && token !== "";
};

// Fazer logout (limpar todos os dados do usuário)
export const logout = () => {
  desinscreverPush().catch(() => {}); // libera este dispositivo das notificações push

  localStorage.removeItem("token");
  localStorage.removeItem("nome_usuario");
  localStorage.removeItem("nomeEstabelecimento");
  localStorage.removeItem("estabelecimento_id");
  localStorage.removeItem("id_cliente");
  localStorage.removeItem("tipo_usuario");
  localStorage.removeItem("funcao_equipe");
  localStorage.removeItem("carrinho");
  localStorage.removeItem("tipoEntrega");
  localStorage.removeItem("dataAgendada");
  localStorage.removeItem("horaAgendada");
  localStorage.removeItem("id_mesa");

  // Redirecionar para login
  window.location.href = "/";
};

// Fazer requisição autenticada (com token no header)
export const fetchWithAuth = async (url, options = {}) => {
  const token = getToken();

  const headers = {
    "Content-Type": "application/json",
    ...options.headers,
  };

  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const response = await fetch(url, {
    ...options,
    headers,
  });

  // Se token expirado ou inválido (401), fazer logout automático
  if (response.status === 401) {
    alert("Sessão expirada. Faça login novamente.");
    logout();
    return null;
  }

  return response;
};

// Obter dados do usuário do localStorage
export const getUserData = () => {
  return {
    nome: localStorage.getItem("nome_usuario"),
    email: localStorage.getItem("email_usuario"),
    tipo: localStorage.getItem("tipo_usuario"),
    id_cliente: localStorage.getItem("id_cliente"),
    estabelecimento_id: localStorage.getItem("estabelecimento_id"),
  };
};
